$(function () {

  const $window　=　$(window);
  const breakpoint = 768;
  const duration = 300;

  function sliderController(element) {
    element.on('inview', function (event, isInView) {
      const $this = $(this);

      if (isInView) {
        $this.slick('slickPlay');
      } else {
        $this.slick('slickPause');
      }
    });
  }

  function setSlider() {
    const $slider = $('.js-slider');

    $slider.slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 6000,
      speed: duration,
      dots: true,
      dotsClass: 'mod-slider__dots',
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    
    sliderController($slider);
  }

  function setTab() {
    const $tab = $('.js-tab');
    const $tabBtn = $('.js-tab-btn');
    const $tabContent = $('.js-tab-content');

    if(location.hash === '#tab_map') {
      $tabBtn.eq(0).toggleClass('is-active', false).end().eq(1).toggleClass('is-active', true);
      $tabContent.eq(0).hide().end().eq(1).fadeIn();
    }

    $tabBtn.click(function () {
      const $this = $(this);
      const tabBtnIndex = $tabBtn.index($this);

      $this.parents($tab).find($tabBtn).removeClass('is-active').eq(tabBtnIndex).addClass('is-active');
      $this.parents($tab).find($tabContent).hide().eq(tabBtnIndex).fadeIn(duration);
    });
  }

  function setShopList() {
    const $shopList = $('.js-shopList');
    const $shopListSwitch = $('.js-shopList-switch');
    const $shopListList = $('.js-shopList-list');
    const $shopListItem = $('.js-shopList-item');
    const $shopListBtn = $('.js-shopList-btn');
    // const num = 9;

    $shopListSwitch.click(function () {
      const $this = $(this);
      const shopListSwitchIndex = $shopListSwitch.index($this);
      const thisData = $this.data('shoplist-switch');

      $this.parents($shopList).find($shopListSwitch).removeClass('is-active').eq(shopListSwitchIndex).addClass('is-active');
      if (thisData === 'thumb') {
        $this.parents($shopList).find($shopListList).removeClass('is-list').addClass('is-thumb');
      } else if (thisData === 'list') {
        $this.parents($shopList).find($shopListList).removeClass('is-thumb').addClass('is-list');
      }
    });

    // $shopList.each(function () {
    //   const $this = $(this);

    //   if ($this.find($shopListItem).length <= num) {
    //     $this.find($shopListBtn).hide();
    //   } else {
    //     $this.find($shopListItem).slice(num).hide();
    //   }
    // });

    // $shopListBtn.click(function () {
    //   const $this = $(this);

    //   $this.parents($shopList).find($shopListItem).slice(num).slideDown(duration);
    //   $this.fadeOut(duration);
    // });
  }

  function smoothScroll() {
    $('a[href^="#"]').click(function () {
      const href = $(this).attr("href");
      const target = $(href == "#" || href == "" ? 'html' : href);
      const position = target.offset().top;
      $('html, body').animate({scrollTop: position}, 600);
      return false;
    });
  }

  setSlider();
  setTab();
  setShopList();
  smoothScroll();

});